import { DEFAULT_NOT_FOUNDED_ROUTE } from '../store'

export const SET_NOT_FOUND_IN_ROUTES = 'SET_NOT_FOUND_IN_ROUTES'
export const CLEAR_NOT_FOUND_IN_ROUTES = 'CLEAR_NOT_FOUND_IN_ROUTES'

export interface NotFoundRoutesState {
    globalRoutes: boolean
    [key: string]: boolean
}

interface SetNotFoundAction {
    type: typeof SET_NOT_FOUND_IN_ROUTES
    routes: string
}

interface ClearNotFoundAction {
    type: typeof CLEAR_NOT_FOUND_IN_ROUTES
}

type NotFoundRoutesAction = SetNotFoundAction | ClearNotFoundAction

/**
 * Set not found route in store
 */
function setNotFounded(state: NotFoundRoutesState, routes: string): NotFoundRoutesState {
    return {
        ...state,
        [routes]: true,
    }
}

/**
 * Clear (set) all not founded params to false
 */
function clearNotFounded(state: NotFoundRoutesState): NotFoundRoutesState {
    return {
        ...state,
        ...DEFAULT_NOT_FOUNDED_ROUTE,
    }
}

/**
 * Reducer for not found routes in store
 */
export default function reducer(
    state: NotFoundRoutesState = [] as unknown as NotFoundRoutesState,
    action: NotFoundRoutesAction,
): NotFoundRoutesState {
    switch (action.type) {
        case SET_NOT_FOUND_IN_ROUTES: return setNotFounded(state, action.routes)
        case CLEAR_NOT_FOUND_IN_ROUTES: return clearNotFounded(state)
        default: return state
    }
}
